import type { ComponentPropsWithRef } from 'react';

import { cn } from '@core/utils/cn';

export interface SkeletonProps extends ComponentPropsWithRef<'div'> {}

/**
 * Use a skeleton, not a spinner, whenever the result has a known shape -- which in this
 * app is almost always. A skeleton communicates what is arriving; a spinner only
 * communicates waiting.
 */
export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={cn(
        'bg-fill-subtle animate-pulse rounded-md motion-reduce:animate-none',
        className,
      )}
      {...props}
    />
  );
}

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} className={cn('h-4', i === lines - 1 && lines > 1 && 'w-2/3')} />
      ))}
    </div>
  );
}
